import { ImageLightness } from "../../../foundation/utils/image";

import { TextureBackgroundVariant } from "./TextureBackground";

export function getTextureVariantFromLightness(
    lightness: ImageLightness
): TextureBackgroundVariant.Light | TextureBackgroundVariant.Dark {
    return lightness === ImageLightness.Dark ? TextureBackgroundVariant.Light : TextureBackgroundVariant.Dark;
}
